import PropTypes from 'prop-types';
import {
  createContext, useContext, useMemo, useState,
} from 'react';
import { useLocation, useParams } from 'react-router';
import AppContext from './App.context';

export const SmartTextSettingsContext = createContext();

export const SmartTextSettingsProvider = ({ children }) => {
  const {
    globalsConfig, accountProperties = { accountProperties: {} },
  } = useContext(AppContext);
  const { isChatGptEnabled: isAiGeneratorFeFlagEnabled = false, isChatGptPhase2Enabled = false } = globalsConfig;
  const { isAiGeneratorEnabled = false } = accountProperties?.accountProperties ?? {};

  const { eventId } = useParams();
  const { pathname } = useLocation();

  const isEventIdAwarePage = useMemo(() => !!eventId && !pathname.includes('create'), [eventId, pathname]);

  const [isSmartTextIconsEnabled, setIsSmartTextIconsEnabled] = useState(false);

  const isSmartTextPromptsDialogEnabled = useMemo(() => isEventIdAwarePage && isAiGeneratorFeFlagEnabled && isAiGeneratorEnabled,
    [isEventIdAwarePage, isAiGeneratorFeFlagEnabled, isAiGeneratorEnabled]);

  const contextValues = useMemo(() => ({
    isSmartTextPromptsDialogEnabled,
    isSmartTextIconsEnabled,
    setIsSmartTextIconsEnabled,
    isChatGptPhase2Enabled,
  }), [
    isSmartTextPromptsDialogEnabled,
    isSmartTextIconsEnabled,
    setIsSmartTextIconsEnabled,
    isChatGptPhase2Enabled,
  ]);

  return (
    <SmartTextSettingsContext.Provider
      value={contextValues}
    >
      {children}
    </SmartTextSettingsContext.Provider>
  );
};

SmartTextSettingsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
